import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";

import { OffersResponse } from "../../../types/rtk/availableOffers/availableOffers";
import { SubscriptionItem } from "../../../types/rtk/currentSubscriptionsOptions/currentSubscriptionsOptions";

import LogoSvg from "../../atoms/LogoSvg/LogoSvg";
import ActiveButton from "../../../assets/images/RADIO-BUTTON-ACTIVE.svg";
import InactiveButton from "../../../assets/images/RADIO-BUTTON-INACTIVE.svg";
import Text from "../../atoms/Text/Text";
import Chip from "../../atoms/Chip/Chip";
import { getYearByMonth } from "../../../helpers/getYearByMonth";
import { formatPrice } from "../../../helpers/currencyHelper";

interface Props {
  offers_data: OffersResponse | null;
  current_subscription?: SubscriptionItem | null;
  isActive: boolean;
  onSelect?: () => void;
}

const ChangeSubscriptionCard = ({ offers_data, current_subscription, isActive, onSelect }: Props) => {
  const { t } = useTranslation();

  const priceComparison = (current_subscription && offers_data)
    ? current_subscription.amount / current_subscription.period > offers_data.amount / offers_data.period
      ? "cheaper"
      : "more_expensive"
    : null;

  return (
    <Box>
      <Box
        className={`ChangeSubscriptionCard ${isActive && "isSubscriptionCardActive"}`}
        onClick={onSelect}
      >
        <Box className="subscriptionRadioButton">
          <LogoSvg src={isActive ? ActiveButton : InactiveButton} />
        </Box>
        <Box className="subscriptionTitle">
          <Text className="bold">
            {
              (offers_data) ? (
                (offers_data.period > 1) ?
                  t("subscription:FIRST_PAGE.SUBSCRIPTION_CHOICE.SUBSCRIPTION_TITLE", { count: getYearByMonth(offers_data.period) })
                  : t("subscription:FIRST_PAGE.SUBSCRIPTION_CHOICE.SUBSCRIPTION_TITLE_MONTHLY")
              )
                : t("subscription:MANAGE_PAGE.EDIT_SUBSCRIPTION.CANCEL.TILE")
            }
          </Text>
          <Text className="price">
            {(offers_data && offers_data.period !== 1) ? (
              t("subscription:PREPAYED", { price: formatPrice(offers_data.amount / 100, offers_data.currency) })
            ) : null}
          </Text>
        </Box>
        {/* Price box on the right side */}
        <Box className="subscriptionPrice">
          {offers_data && (
            <Box className="prices">
              <Text className={offers_data.period !== 1 ? "color bold" : "bold"}>
                {`${formatPrice(offers_data.amount / 100 / offers_data.period, offers_data.currency)}`}
              </Text>
              <Text className="bold">
                {` / ${t("subscription:MONTH")}`}
              </Text>
            </Box>
          )}
          {priceComparison === "cheaper" && current_subscription && offers_data && (
            <Chip
              text={t("subscription:MANAGE_PAGE.EDIT_SUBSCRIPTION.SAVINGS_PER_YEAR", { price: formatPrice((current_subscription.amount / current_subscription.period - offers_data.amount / offers_data.period) * 12 / 100, current_subscription.currency) })}
              isActive={false}
              className="green"
            />
          )}
          {priceComparison === "more_expensive" && current_subscription && offers_data && (
            <Chip
              text={t("subscription:MANAGE_PAGE.EDIT_SUBSCRIPTION.OVERCHARGE_PER_YEAR",
                { price: formatPrice((offers_data.amount / offers_data.period - current_subscription.amount / current_subscription.period) * 12 / 100, offers_data.currency) }
              )}
              isActive={false}
              className="red"
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default ChangeSubscriptionCard;